export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu': 'Marketplace',
  'menu.order': 'Orders',
  'menu.order-fulfillment': 'Platform Order',
  'menu.order-fulfillment.fulfillment-request': 'Fulfillment',
  'menu.order-fulfillment.wms-pre-order': 'WMS Pre Order',
  'menu.order-fulfillment.wms-accepted': 'WMS Accepted',
  'menu.order-fulfillment.wms-inprogess': 'WMS Inprogress',
  'menu.order-fulfillment.platform-order': 'Platform Order (All)',
  'menu.order-fulfillment.fulfillment-order': 'Fulfillment Order',
  'menu.order-fulfillment.ready-to-ship': 'Ready To Ship',
  'menu.order-fulfillment.packed-order': 'Packed Order',
  'menu.order-fulfillment.shipped-order': 'Shipped Order',
  'menu.order-fulfillment.orderDetail': 'Order Detail',
  'menu.order-fulfillment.rejected-label': 'Rejected Label',
  'menu.order-handle-stock': 'Order Stock Handling',
  'menu.order-handle-stock.require-allocate-stock': 'Require Allocate Stock',
  'menu.order-handle-stock.allocated-stock': 'Allocated Stock',
  'menu.order-handle-stock.interface-pack-stock': 'Packed, Ready to Ship (Feedback)',
  'menu.order-handle-stock.require-ship-stock': 'Require Ship',
  'menu.order-handle-stock.interface-cancel-stock': 'Exception / Cancel (Feedback)',
  'menu.order-handle-stock.cancelled-by-platform': 'Cancelled By Platform',
  'menu.inventory': 'Inventory',
  'menu.inventory.platform-inventory': 'Platform Inventory',
  'menu.inventory.interface-inventory': 'Inventory (SAP Feedback)',
  'menu.inventory.morellato-inventory': 'Morellato Inventory',
  'menu.platform-product': 'Platform Product',
  'menu.report': 'Report',
  'menu.store': 'Stores',
  'menu.marketplace-commission': 'Commission',
  'menu.marketplace-category': 'Marketplace Category',
  'menu.payment-gateway': 'Payment Gateway',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.settings': 'Setting',
};
